export default "__VITE_ASSET__CsVYaZr4__"